/*@ngInject*/
const DateUtil = function() {

    this.formatDate = function(millis, format) {
        if (!format) {
            format = 'MM/DD/YYYY';
        }
        let value = moment(millis);
        return value.format(format);
    };

    this.formatTime = function(millis, format) {
        if (!format) {
            format = 'h:mm a';
        }
        return this.formatDate(millis, format);
    };

    this.formatShortDate = function(date, utc) {
        let isValid = moment(date).isValid(),
            result = date;

        if(isValid) {
            let momentObject = moment(date);
            if(utc){
                momentObject = momentObject.utc();
            }
            result = momentObject.format('MM/DD/YY');
        }

        return result;
    };

    this.formatShortDateAndTime = function(date, utc) {
        let isValid = moment(date).isValid(),
            result = date;

        if(isValid) {
            let momentObject = moment(date);
            if(utc){
                momentObject = momentObject.utc();
            }
            result = momentObject.format('MM/DD/YY HH:mm A');
        }

        return result;
    };

    this.formatShortDateAndTimeLongYearAmPm = function(date, utc) {
        let isValid = moment(new Date(date)).isValid(),
            result = date;

        if(isValid) {
            let momentObject = moment(new Date(date));
            if(utc){
                momentObject = momentObject.utc();
            }
            result = momentObject.format('MM/DD/YYYY hh:mm A');
        }

        return result;
    };

    this.formatShortDateWithLongYear = function(date, utc) {
        let isValid = moment(date).isValid(),
            result = date;

        if(isValid) {
            let momentObject = moment(date);
            if(utc){
                momentObject = momentObject.utc();
            }
            result = momentObject.format('MM/DD/YYYY');
        }

        return result;
    };

    this.formatMediumDate = function(date, utc) {
        let isValid = moment(date).isValid(),
            result = date;

        if(isValid) {
            let momentObject = moment(date);
            if(utc){
                momentObject = momentObject.utc();
            }
            result = momentObject.format('MMM. DD, YYYY');
        }
        return result;
    };

    this.formatServerDate = function(date) {
        let isValid = moment(date).isValid(),
            result = date;

        if(isValid) {
            result =  moment(date).unix();
        }

        return result;
    };

    this.formatUtcDateRangeString = function(startDate, endDate) {
        return this.formatDateRangeString(startDate, endDate, true);
    };

    this.formatLocalDateRangeString = function(startDate, endDate) {
        return this.formatDateRangeString(startDate, endDate, false);
    };

    this.formatDateRangeString = function(startDate, endDate, utc) {
        let momentStartDate = utc ? moment.utc(startDate) : moment(startDate),
            momentEndDate = utc ? moment.utc(endDate) : moment(endDate),
            isValidStartDate = momentStartDate.isValid(),
            isValidEndDate = momentEndDate.isValid(),
            startDateString = isValidStartDate ? momentStartDate.format('MM/DD/YYYYZZ') : ' ',
            endDateSting = isValidEndDate ? momentEndDate.format('MM/DD/YYYYZZ') : ' ';

        return `SPECIFIED::${startDateString}::${endDateSting}`;
    };

    this.parseDateRangeStartDateToMilliseconds = function(dateRangeString) {
        let dateParts = _.split(dateRangeString, '::'),
            startDate = moment(dateParts[1], 'MM/DD/YYYYZZ'),
            isValidStartDate = startDate.isValid();

        return isValidStartDate ? startDate.valueOf() : null;
    }

    this.parseDateRangeEndDateToMilliseconds = function(dateRangeString) {
        let dateParts = _.split(dateRangeString, '::'),
            endDate = moment(dateParts[2], 'MM/DD/YYYYZZ'),
            isValidEndDate = endDate.isValid();

        return isValidEndDate ? endDate.valueOf() : null;
    }

    this.isBefore = function(date, comparisonDate) {
        return moment(date).isBefore(comparisonDate);
    };

    this.isAfter = function(date, comparisonDate) {
        return moment(date).isAfter(comparisonDate);
    };

    this.isSame = function(date, comparisonDate) {
        return moment(date).isSame(comparisonDate, 'day');
    };

    this.getSeconds = function(date) {
        let now = moment(new Date()).unix(),
            pastDate = moment(date).unix();
        return now - pastDate;
    };

    this.generateRandomDate = function(start, end) {
        return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
    };

    this.add = function(date, additionTotal) {
        moment(date).add(additionTotal, 'days').toDate();
    };

    this.subtract = function(date, subtractionTotal) {
        return moment(date).subtract(subtractionTotal, 'days').toDate();
    };

    this.isValidDate = function(date) {
        return moment(new Date(date)).isValid();
    };

    this.getFirstDayOfLastMonth = function(date) {
        return moment(new Date).subtract(1, 'months').startOf('month').toDate();
    };

    this.getLastDayOfLastMonth = function(date) {
        return moment(new Date).subtract(1, 'months').endOf('month').toDate();
    };

};

angular.module('umCore')
    .service('dateUtil', DateUtil);
